import { useMutation, useQueryClient } from '@tanstack/react-query'

import { putRequest } from 'src/lib/api-client'
import { queries } from 'src/lib/query-keys'
import type { StreamPost, UpdatePostData } from 'src/shared/schemas/stream/feed'

const updatePost = (data: UpdatePostData) => putRequest<StreamPost>('/feeds/posts/update', data)

export const useUpdatePost = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: updatePost,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: queries.feeds._def })
    },
  })
}
